import { Component, Input, Output, EventEmitter } from "@angular/core";
import { Community, CommunityListConfig } from "../../../../../models";

@Component({
  selector: "community-preview",
  templateUrl: "./community-preview.component.html",
  styleUrls: [
    "./community-preview.component.scss",
    "../../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class CommunityPreviewComponent {
  private defaultCommunityImg: string =
    "../../../../../../../assets/images/uMuzi/shield.png";
  @Input() query: CommunityListConfig;
  @Input() community: Community;
  @Output() setTagTo = new EventEmitter<any>();

  public setTagFeed(tag: string) {
    this.setTagTo.emit(tag);
  }
}
